import React, { useEffect, useState } from "react";
import { ToggleButtonGroup, ToggleButton, Button, TextField, Input } from "react-aria-components";
import API from 'libs/api';

import CMP_STAT from './cmp_stat/cmp_stat';

import './crd_stats.css';
import ICON from "../../../../components/cmp_icon/cmp_icon";


export default function CRD_STATS({ currentStatus, onStatusChange }) {

  const [data, setData] = useState([]);
  const [processing, setProcessing] = useState('inactive');
  const [ready, setReady] = useState(false);

  const colorGreen = 'var(--color-green-500)';
  const colorGray = 'var(--color-gray-150)';
  const colorOrange = 'var(--color-orange-500)';
  const colorRed = 'var(--color-red-500)';

  const [providerBreakdown, setProviderBreakdown] = useState([]);
  const [classificationBreakdown, setClassificationBreakdown] = useState([]);
  const [scrapingBreakdown, setScrapingBreakdown] = useState([]);
  const [extractionBreakdown, setExtractionBreakdown] = useState([]);
  const [publishBreakdown, setPublishBreakdown] = useState([]);

  const providerSchema = [
    { status: 'YES', color: colorGreen },
    { status: 'NO', color: colorRed },
    { status: 'POSSIBLE', color: colorOrange }
  ];

  const classificationSchema = [
    { status: 'COMPLETE', color: colorGreen },
    { status: 'FAILED', color: colorRed },
    { status: 'PENDING', color: colorGray }
  ];

  const scrapingSchema = [
    { status: 'PENDING', color: colorGray },
    { status: 'FAILED', color: colorRed },
    { status: 'BLOCKED', color: colorOrange }
  ];

  const extractionSchema = [
    { status: 'PENDING', color: colorGray },
    { status: 'REVIEW', color: colorOrange },
    { status: 'FAILED', color: colorRed }
  ];

  const publishedSchema = [
    { status: 'PENDING', color: colorGray },
    { status: 'PUBLISHED', color: colorGreen },
    { status: 'FAILED', color: colorRed }
  ];

  useEffect(() => {
    populateStats();
  }, []);

  async function populateStats() {
    setReady(false);
    setProcessing('processing');

    try {
      const results = await API.get('admin-domains', '/get-domain-stats');
      setData(results);

      if (results.provider?.breakouts) {
        setProviderBreakdown(mergeWithSchema(results.provider.breakouts, providerSchema));
      }
      if (results.classification?.breakouts) {
        setClassificationBreakdown(mergeWithSchema(results.classification.breakouts, classificationSchema));
      }
      if (results.scraping?.breakouts) {
        setScrapingBreakdown(mergeWithSchema(results.scraping.breakouts, scrapingSchema));
      }
      if (results.extraction?.breakouts) {
        setExtractionBreakdown(mergeWithSchema(results.extraction.breakouts, extractionSchema));
      }
      if (results.published?.breakouts) {
        setPublishBreakdown(mergeWithSchema(results.published.breakouts, publishedSchema));
      }

      setProcessing('inactive');
      setReady(true);
    } catch (e) {
      console.error('Error fetching stats:', e);
      setProcessing('error');
    }
  }

  function mergeWithSchema(breakouts, schema) {
    return schema.map(schemaItem => ({
      label: formatLabel(schemaItem.status),
      value: breakouts[schemaItem.status] || 0,
      color: schemaItem.color
    }));
  }

  function formatLabel(status) {
    if (!status) return 'Unknown';
    return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
  }

  return (
    <div className='domains stat__wrapper'>
      <div className='stat__wrapper--inner'>
        <CMP_STAT
          status='Domains'
          total={data.provider?.total}
          breakdown={providerBreakdown}
          ready={ready}
          onSelect={() => onStatusChange('DOMAINS')}
          isSelected={currentStatus === 'DOMAINS'}
        />
        <CMP_STAT
          status='Classifications'
          total={data.classification?.total}
          breakdown={classificationBreakdown}
          ready={ready}
          onSelect={() => onStatusChange('CLASSIFICATION')}
          isSelected={currentStatus === 'CLASSIFICATION'}
        />
        <CMP_STAT
          status='Scraping'
          total={data.scraping?.total}
          breakdown={scrapingBreakdown}
          ready={ready}
          onSelect={() => onStatusChange('SCRAPE')}
          isSelected={currentStatus === 'SCRAPE'}
        />
        <CMP_STAT
          status='Extractions'
          total={data.extraction?.total}
          breakdown={extractionBreakdown}
          ready={ready}
          onSelect={() => onStatusChange('EXTRACTION')}
          isSelected={currentStatus === 'EXTRACTION'}
        />
        <CMP_STAT
          status='Published'
          total={data.published?.total}
          breakdown={publishBreakdown}
          ready={ready}
          onSelect={() => onStatusChange('PUBLISH')}
          isSelected={currentStatus === 'PUBLISH'}
        />
      </div>

      <div className='stat__wrapper--actions'>
        <Button className='tertiary' onClick={populateStats}>
          <ICON name='refresh' className='icon' alt='refresh icon' />
          Refresh stats
        </Button>
      </div>
    </div>
  );
}